export function wasEdited(originalTranslation, editedTranslation) {
  return (originalTranslation || '').trim() !== (editedTranslation || '').trim();
}

export function validateClassification({ wasEdited, errorCategory, severity }) {
  if (!wasEdited) {
    return null;
  }
  if (!errorCategory || !severity) {
    return 'Error Category and Severity are required when the translation is edited.';
  }
  return null;
}
